import React from 'react';
import defaultLuminaireImage from './../../assets/images/default_luminaire_image.png';

type Props = {
    dataTestId: string;
    imageURL?: string;
    width?: number;
    useDefaultImage?: boolean;
};

export const LumImage: React.FC<Props> = (props) => {

    const { imageURL = '', width = 100, dataTestId, useDefaultImage = true } = props;
    const normalizedImageURL = imageURL.trim();
    const [hideImage, setHideImage] = React.useState(false);
    const resolvedImageURL = normalizedImageURL || (useDefaultImage ? defaultLuminaireImage : '');
    const altText = resolvedImageURL ? 'Luminaire image' : 'No Image Available';

    if (hideImage || !resolvedImageURL) {
        return null;
    }

    return (
        <img
            data-testid={dataTestId}
            src={resolvedImageURL}
            alt={altText}
            loading="lazy"
            style={{ width: width }}
            onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                if (!useDefaultImage) {
                    setHideImage(true);
                    return;
                }
                if (e.currentTarget.src.includes('default_luminaire_image')) {
                    return;
                }
                e.currentTarget.onerror = null;
                e.currentTarget.src = defaultLuminaireImage;
                e.currentTarget.alt = 'No Image Available';
            }}
        />
    );
}
